import { Stack } from '@chakra-ui/layout'
import React, { createElement, useMemo } from 'react'

import blockElements from './blockElements'
import handleLinks from './handleLinks'
import ErrorBoundary from '../../components/ErrorBoundary'
import useSlug from '../Layout/useSlug'
import arrToObj from '../../helpers/arrToObj'

const Blocks = ({ blocks, links: linkArr, id: profileId }) => {
  const slug = useSlug()
  const links = useMemo(() => handleLinks(arrToObj(linkArr, 'linkId'), slug), [linkArr, slug])
  const sortedBlock = useMemo(() => blocks.sort((a, b) => a.order - b.order), [blocks])
  return (
    <Stack width="full" spacing="1em">
      {sortedBlock.map((b, key) => !b.hidden && (
        <ErrorBoundary key={key}>
          {createElement(blockElements[b.type], { ...b, profileId, links })}
        </ErrorBoundary>
      ))}
    </Stack>
  )
}

export default Blocks
